// extracted by mini-css-extract-plugin
export default {"block":"kQYwZ","bold":"jjCOl","icon":"sCHxg","tooltip":"yvDaV"};